import api from "@/lib/api";

export const ACCOUNT_PREVIEW_LIMIT = 100;
export const ACCOUNT_AGING_LIMIT = 60;

export const today = new Date().toISOString().slice(0, 10);
export const monthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);

export function blankTemplate() {
  return {
    template_name: "Tally Sales Import",
    export_type: "sales",
    file_type: "xlsx",
    include_header: true,
    date_format: "2006-01-02",
    amount_format: "0.00",
    column_separator: ",",
    columns: [
      { column_order: 1, column_header: "Voucher Type", mapped_field: "", static_value: "Sales", default_value: "", transformation: "", required: true },
      { column_order: 2, column_header: "Invoice No", mapped_field: "invoice_number", static_value: "", default_value: "", transformation: "", required: true },
      { column_order: 3, column_header: "Party Ledger", mapped_field: "party_ledger_name", static_value: "", default_value: "", transformation: "", required: true },
      { column_order: 4, column_header: "Amount", mapped_field: "final_amount", static_value: "", default_value: "0", transformation: "", required: true },
    ],
  };
}

const requestConfig = (params) => ({ params, skipGlobalLoader: true });

export const accountApi = {
  summary: (filters) => api.get("/accounts/summary", requestConfig(filters)),
  schema: () => api.get("/accounts/export-schema", { skipGlobalLoader: true }),
  campaignInvoiceCandidates: () => api.get("/accounts/campaign-invoice-candidates", requestConfig({ limit: 20 })),
  createCampaignInvoice: (campaignId) => api.post(`/accounts/campaigns/${campaignId}/invoice`, {}, { skipGlobalLoader: true }),
  invoices: (filters) => api.get("/accounts/invoices", requestConfig({ ...filters, limit: ACCOUNT_PREVIEW_LIMIT })),
  payments: (filters) => api.get("/accounts/payments", requestConfig({ ...filters, limit: ACCOUNT_PREVIEW_LIMIT })),
  payables: (filters) => api.get("/accounts/payables", requestConfig({ ...filters, limit: ACCOUNT_PREVIEW_LIMIT })),
  gstSummary: (filters) => api.get("/accounts/gst-summary", requestConfig(filters)),
  templates: () => api.get("/accounts/export-templates", { skipGlobalLoader: true }),
  ledgers: () => api.get("/accounts/ledger-mappings", { skipGlobalLoader: true }),
  periods: () => api.get("/accounts/periods", { skipGlobalLoader: true }),
  reconciliation: () => api.get("/accounts/reconciliation", requestConfig({ limit: 50 })),
  trialBalance: (filters) => api.get("/accounts/trial-balance", requestConfig(filters)),
  receivableAging: (filters) => api.get("/accounts/receivable-aging", requestConfig({ as_of: filters.to, limit: ACCOUNT_AGING_LIMIT })),
  payableAging: (filters) => api.get("/accounts/payable-aging", requestConfig({ as_of: filters.to, limit: ACCOUNT_AGING_LIMIT })),
};

export function downloadBlob(response, fallbackName) {
  const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/octet-stream" });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = match?.[1] || fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
